//VendorCaseStudiesSectionBottom
import React from "react";
import TopSection from "./VendorCaseStudiesSectionTop";
import Pagination from "../../../Common/PaginationPremium";
import VendorCaseStudiesLocked from "./VendorCaseStudiesLocked";
import { connect } from "react-redux";
import SearchResultPremium from "../../../Common/SearchResultPremium";
import SponsoredBox from "../../../Common/PeerBoxes/SponsoredBox";
import CompetitorBoxes from "../../../Common/PeerBoxes/CompetitorBoxes";
import { updateCaseStudiesReviews } from "../../../../store/actions/vendorCaseStudiesActions";
import Loader from "../../../Common/Loader";
import PaginationPremium from "../../../Common/PaginationPremium";

class VendorCaseStudiesSectionBottom extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = this.state = {
      paginationOn: 1,
      itemOnPage: 15,
      totalReferences: 77,
      currentlyShowing: "1-12",
      isLoader: false,
    };
    this.updateState = this.updateState.bind(this);
    this.toggleLoader = this.toggleLoader.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  updateState = (newValues) => {
    if (this._isMounted) {
      this.setState((prevState) => {
        return {
          ...prevState,
          ...newValues,
        };
      });
    }
  };

  setPaginationOn = (number) => {
    this.setState({ paginationOn: number });
  };

  setItemOnPage = (iValue) => {
    this.setState({ itemOnPage: iValue });
  };

  toggleLoader = () => {
    if (this._isMounted) {
      this.setState((prevState) => {
        return {
          isLoader: !prevState.isLoader,
        };
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <div className="vendor_reviews_section case_study">
          <div className="vendor_portal_top_header_block">
            {/* {ShowContentOnCaseStudy(
                          EnhancedVendorCaseStudiesSnap,
                          props?.location?.pathname
                        )} */}
          </div>
          <div className="case_study_reviews clsVerified">
            <TopSection {...this.props} {...this.state} />
          </div>
          {this.props.vendorCommon.show_sponsored_popup ? (
            <SponsoredBox {...this.props.vendorCommon} />
          ) : (
            <CompetitorBoxes {...this.props.vendorCommon} />
          )}
          <div className="vendor_list">
            <VendorCaseStudiesLocked {...this.props} {...this.state} />
          </div>
        </div>

        <PaginationPremium
          {...this.props}
          paginationOn={this.state.paginationOn}
          setPaginationOn={this.setPaginationOn}
          itemOnPage={this.state.itemOnPage}
          setItemOnPage={this.setItemOnPage}
          pageData={Array.apply(
            null,
            Array(this.props?.vendorCaseStudies?.pagination?.num_pages)
          ).map((val, idx) => ({ page: idx + 1 }))}
          paginationInfo={this.props.vendorCaseStudies.pagination}
          toggleLoader={this.toggleLoader}
        />

        {/* {this.state.isLoader ? <Loader /> : null} */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    vendorCommon: state.vendorCommon,
    vendorCaseStudies: state.vendorCaseStudies,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateReview: (URL, pagenumber) =>
      dispatch(updateCaseStudiesReviews(URL, pagenumber)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorCaseStudiesSectionBottom);
